module.exports = __webpack_public_path__ + "media/phiphi/phiphi-e9d9e5db.jpg";